"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.Root = (0, styles_1.styled)(material_1.Box)({
    display: "flex",
    justifyContent: "flex-end",
});
//# sourceMappingURL=styled.js.map